import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as AmberAlertTriangle } from '../../../assets/images/svg/amber-alert-triangle.svg';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from './SfhSecondaryButton';

const DrawerWrapper = styled.div`
  h2 {
    color: ${themeColors.colorTextPrimary};
  }
`;

const StepsList = styled.ul`
  list-style: disc;
  padding-left: 20px;
  margin: 8px 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Step = styled.li`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: ${themeColors.colorTextSecondary};
`;

const WarningPill = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ${themeColors.colorBackgroundSecondary};
  border-radius: 6px;
  padding: 12px 16px;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: ${themeColors.colorTextSecondary};

  > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    color: ${themeColors.colorPrimary};
    font-weight: 700;
  }
`;

const SellFromHomeWhatHappensNextDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <SfhSecondaryButton
        onClick={onClose}
        data-cy="button-sfh-what-happens-next-understood"
      >
        {t('sellWizard.sfhWizard.whatHappensNextDrawer.understood')}
      </SfhSecondaryButton>
    </DrawerFooter>
  );

  return (
    <DrawerWrapper>
      <BottomDrawer
        isOpen={isOpen}
        onClose={onClose}
        title={t('sellWizard.sfhWizard.whatHappensNextDrawer.title')}
        footer={footer}
        maxHeight="80%"
      >
        <StepsList>
          <Step>{t('sellWizard.sfhWizard.whatHappensNextDrawer.step1')}</Step>
          <Step>{t('sellWizard.sfhWizard.whatHappensNextDrawer.step2')}</Step>
          <Step>{t('sellWizard.sfhWizard.whatHappensNextDrawer.step3')}</Step>
          <Step>{t('sellWizard.sfhWizard.whatHappensNextDrawer.step4')}</Step>
        </StepsList>
        <WarningPill>
          <AmberAlertTriangle />
          <span>{t('sellWizard.sfhWizard.whatHappensNextDrawer.warning')}</span>
        </WarningPill>
      </BottomDrawer>
    </DrawerWrapper>
  );
};

SellFromHomeWhatHappensNextDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomeWhatHappensNextDrawer;
